import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { ExistingLesson } from 'types/admin/modules';

export class ExistingLessonsService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getExistingLessons = async () => {
    const response = await this.axiosInstance.get<Result<ExistingLesson[]>>(`/api/admin/learning-materials`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while getting learning materials.');
  };
}
